import React, { FC } from "react";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/CreateOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { ISectionCTA } from "../ISectionCTA";
import { useCreatorThemeContext } from "../../../../../features/Common/modules/Theme/CreatorThemeContext";
import { classNames } from "../../../../../utils/common/styling";
import { styles } from "./SimpleSectionCTA.styles";
import { SectionCTAContent } from "../SectionCTAContent/SectionCTAContent";
import { setOpacity } from "../../../../../utils/common/common";

export const SimpleSectionCTA: FC<ISectionCTA.IProps> = ({
  label,
  active,
  icon,
  isChannelLocked,
  onClick,
  className,
  labelClassName,
  labelStyle,
  showActions,
  onEdit,
}) => {
  const theme = useCreatorThemeContext();

  return (
    <div
      onClick={onClick}
      className={classNames(
        styles.root,
        active ? styles.active : styles.inactive,
        className,
      )}
    >
      <div className={styles.container}>
        {/* LEFT SIDE */}
        <div className={styles.left}>
          <SectionCTAContent
            label={label}
            icon={icon}
            active={active || false}
            labelClassName={labelClassName}
            labelStyle={labelStyle}
            theme={theme}
          />
        </div>

        {/* RIGHT SIDE */}
        <div className={styles.right}>
          {isChannelLocked && (
            <LockOutlinedIcon
              style={{
                fontSize: 18,
                color: active ? theme?.colors?.color1 : setOpacity("#000", 0.8),
              }}
            />
          )}

          {!isChannelLocked && !showActions && (
            <ChevronRightIcon
              style={{
                fontSize: 20,
                color: active ? theme?.colors?.color1 : setOpacity("#000", 0.8),
              }}
            />
          )}

          {showActions && (
            <div className={styles.actions}>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit?.(e);
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
